import { useEffect, useState } from "react";
import api from "../lib/api";
import { MaskedLine, Reveal } from "../components/Reveal";
import EditorialMarquee from "../components/Marquee";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-6", "md:col-span-6"];

export default function Lookbook() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/lookbook").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="lookbook-page">
      <section className="max-w-7xl mx-auto px-4 md:px-12 pt-32 pb-14">
        <MaskedLine delay={0.1}><p className="eyebrow mb-5">Lookbook — Vol. 01</p></MaskedLine>
        <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight text-white">
          <MaskedLine delay={0.25}>Made in</MaskedLine>
          <MaskedLine delay={0.37}><span className="text-kinetic">Kilgore, Texas</span></MaskedLine>
        </h1>
        <MaskedLine delay={0.5}>
          <p className="mt-8 max-w-md text-zinc-400 leading-relaxed">
            Small town. Heavy fabric. Every Coleman Customs piece is printed, stitched and dispatched from our workshop in Kilgore — East Texas grit in every seam.
          </p>
        </MaskedLine>
      </section>

      <EditorialMarquee />

      <section className="max-w-7xl mx-auto px-4 md:px-12 py-20">
        {items === null ? (
          <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 py-20 text-center" data-testid="lookbook-loading">Loading the gallery…</p>
        ) : items.length === 0 ? (
          <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 py-20 text-center" data-testid="lookbook-empty">Photos from the workshop dropping soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-12 gap-5" data-testid="lookbook-grid">
            {items.map((it, i) => (
              <Reveal key={it.id} delay={(i % 3) * 0.08} className={SPANS[i % SPANS.length]}>
                <figure className="group relative overflow-hidden clipped-frame border border-white/10" data-testid={`lookbook-item-${i}`}>
                  <img
                    src={it.image}
                    alt={it.caption || "Coleman Customs lookbook"}
                    loading="lazy"
                    className="w-full h-full object-cover aspect-[4/3] grayscale-[35%] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-500"
                  />
                  <figcaption className="absolute bottom-0 left-0 right-0 bg-black/70 backdrop-blur px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-300 flex justify-between gap-4">
                    <span className="truncate">{it.caption}</span>
                    <span className="text-kinetic shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        )}
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-12 pb-10">
        <Reveal>
          <div className="border border-white/10 bg-card p-10 md:p-14 text-center">
            <p className="eyebrow mb-4">Local pride</p>
            <h2 className="font-display text-3xl md:text-5xl uppercase tracking-tight">From the 903 to your door</h2>
            <p className="mt-6 max-w-lg mx-auto text-zinc-400 leading-relaxed">
              No faceless fulfillment centers. Your order is made by hand in Kilgore and shipped straight to you — usually within 48 hours.
            </p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
